import { Button } from "antd";

export const BackNextButton = ({
  text,
  onClick,
  disabled,
}: {
  text: string;
  onClick: () => void;
  disabled: boolean;
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      style={{
        border: "none",
        background: "none",
        color: disabled ? "grey" : "blue",
        cursor: disabled ? "default" : "pointer",
        padding: 0,
      }}>
      {text}
    </Button>
  );
};
